import { useContext } from 'react';
import { config } from '../../config';
import { AccountInfoContext } from '../../contexts/AccountInfoContext';
import { ActiveProductsNumberCard } from '../Analytics/Common/Cards/ActiveProductsNumberCard';
import { OrdersNumberCard } from '../Analytics/Common/Cards/OrdersNumberCard';
import { TotalRevenueCard } from '../Analytics/Common/Cards/TotalRevenueCard';
import { RevenueChart } from '../Analytics/Common/Charts/RevenueChart';
import { StepsPanelExistingUser } from '../Common/Help/StepsPanels';
import { WelcomePanel } from '../Common/WelcomePanel';
import { LowStockProducts } from './LowStockProducts';

export const HomePage = () => {
  const { accountInfo } = useContext(AccountInfoContext);
  return (
    <div className="m-home">
      <WelcomePanel />
      <StepsPanelExistingUser />
      {config.showAnalytics && accountInfo.usesAnalytics && (
        <>
          <div className="mydash-budget-cards">
            <div className="row equal-heights-content">
              <div className="col col-4  col-md-6 col-xs-3">
                <OrdersNumberCard />
              </div>
              <div className="col col-4  col-md-6 col-xs-3">
                <TotalRevenueCard />
              </div>
              <div className="col col-4  col-md-6 col-xs-3">
                <ActiveProductsNumberCard />
              </div>
            </div>
          </div>
          <RevenueChart />
        </>
      )}
      <LowStockProducts />
    </div>
  );
};
